import { window_size, inview_animate, header_scroll } from "./modules/theme";
import { viewport_less_than_360 } from "./modules/viewport";
import { humburger_menu, drawer_menu } from "./modules/humburger-menu";
import { global_menu, global_menu_current } from "./modules/global-menu";
import { scroll_hint } from "./modules/scroll-hint";
// import { kvSplide } from "./modules/splide";
import { toc } from "./modules/toc";
import { image_map_resizer } from "./modules/image-map-resizer";

import { history_scroll } from "./modules/history-scroll";
import { background_scroll } from "./modules/background-scroll";

import { count_up } from "./modules/count-up";
import { card_hover_state } from "./modules/card-hover-state";
import { floating_banner } from "./modules/floating-banner";

import { company_animation } from './modules/company-animation';
import { page_lv2_header_animation } from './modules/header-animation';


window_size();
inview_animate();
viewport_less_than_360();

header_scroll();

global_menu();
global_menu_current();
humburger_menu();
drawer_menu();
scroll_hint();
// kvSplide();
// year_select();
toc();
// rwd_image_maps();
// image_map_resizer();

history_scroll();
background_scroll();

count_up();
card_hover_state();

floating_banner();

page_lv2_header_animation();

// FES
document.addEventListener('DOMContentLoaded', () => {
	company_animation();
});
